// src/features/trackingSlice.ts

import { Action, createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import UpdateTrackingAddressApi from '../../api/TrackingAddressApi'
import {  CountryListItem, UserVerifyPostcodeResponse, Verifyinfo } from '../../api/response_type/UserVerifyPostcodeResponse';
import { UserVerifyPostcodeRequest } from '../../api/request_type/UserVerifyPostcodeRequest';
import { UpdateContactAddressRequest } from '../../api/request_type/UpdateContactAddressRequest';
import { UpdateContactAddressResponse } from '../../api/response_type/UpdateContactAddressResponse';
import { Data, UpdateTrackingAddressRequest } from '../../api/request_type/UpdateTrackingAddressRequest';
import { UpdateTrackingAddressResponse } from '../../api/response_type/UpdateTrackingAddressResponse';
import { verifyAddressRequest } from '../../api/request_type/VerifyAddressRequest';
import { verifyAddressResponse } from '../../api/response_type/VerifyAddressResponse';

type TrackingState = {
  isLoading:boolean;
  userData:Data;
  newuserData:Data;
  verifydata:Verifyinfo;
  countryInfo:CountryListItem[];
  verifiedID:number | null;
  status:boolean;
  lat:number;
  long:number;
}

const initialState: TrackingState = {
  isLoading:false,
  userData:{} as Data,
  newuserData:{} as Data, 
  verifydata:{} as Verifyinfo,
  countryInfo:[] as CountryListItem[],
  verifiedID:null,
  status:false,
  lat: 0,
  long: 0,
};
export const UserVerifyFromPostCodeThunk = createAsyncThunk(
  'UserVerifyFromPostCodeThunk',
  async (payload: UserVerifyPostcodeRequest): Promise<UserVerifyPostcodeResponse> => {
    let api = new UpdateTrackingAddressApi();
    return api.UserVerifyFromPostCode(payload);
  },
);
export const UpdateContactAddressActionThunk = createAsyncThunk(
  'UpdateContactAddressActiongThunk',
  async (payload: UpdateContactAddressRequest): Promise<UpdateContactAddressResponse> => {
    let api = new UpdateTrackingAddressApi();
    return api.UpdateContactAddressAction(payload);
  },
);
export const UpdateTrackingAddressActionThunk = createAsyncThunk(
  'UpdateTrackingAddressActionThunk',
  async (payload: UpdateTrackingAddressRequest): Promise<UpdateTrackingAddressResponse> => {
    let api = new UpdateTrackingAddressApi();
    return api.UpdateTrackingAddressAction(payload);
  },
);
export const verifyAddressThunk = createAsyncThunk(
  'DownloadPodThunk',
  async (payload: verifyAddressRequest): Promise<verifyAddressResponse> => {
    let api = new UpdateTrackingAddressApi();
    return api.UpdateVerifyAddress(payload);
  },
);
const UpdateTrackingAddressSlice = createSlice({
  name: 'UpdateTrackingAddressSlice',
  initialState,
  reducers: {
    resetstatus:state =>{
      state.status = false;
    },
    resetData:state =>{
      state.newuserData.shipment_address1= '';
      state.newuserData.shipment_state = '';
      state.newuserData.shipment_address2= '';
      state.newuserData.shipment_customer_city= '';
    },
    updateCustomerEmail:(state,action:PayloadAction<string>)=>{
      state.newuserData.shipment_customer_email=action.payload;
    },
    updateCustomerName:(state,action:PayloadAction<string>)=>{
      state.newuserData.shipment_customer_name=action.payload;
    },
    updateCustomerPhone:(state,action:PayloadAction<string>)=>{
      state.newuserData.shipment_customer_phone=action.payload;
    },
    updateShipmentAddress1:(state,action:PayloadAction<string>)=>{
      state.newuserData.shipment_address1=action.payload;
    },
    updateShipmentAddress2:(state,action:PayloadAction<string>)=>{
      state.newuserData.shipment_address2=action.payload;
    },
    updateShipmentCity:(state,action:PayloadAction<string>)=>{
      state.newuserData.shipment_customer_city=action.payload;
    },
    updateShipmentState:(state,action:PayloadAction<string>)=>{
      state.newuserData.shipment_state=action.payload;
    },
    updateShipmentCountry:(state,action:PayloadAction<{name:string,code:string}>)=>{
      state.newuserData.shipment_customer_country = action.payload.name;
     // console.log(state.newuserData.shipment_customer_country);
      state.newuserData.shipment_country_code =action.payload.code;
    },
    updateShipmentCountryCode:(state,action:PayloadAction<string>)=>{
      state.newuserData.shipment_country_code =action.payload;
    },
    updateShipmentPostcode:(state,action:PayloadAction<string>)=>{
      state.newuserData.shipment_postcode=action.payload;
    },
    setLatLong:(state, action: PayloadAction<{
      lat:string,
      long:string,
    }>)=>{
      state.newuserData.shipment_latitude=action.payload.lat;
      state.newuserData.shipment_longitude=action.payload.long;
    },
    updateShipmentCountrylist:(state,action:PayloadAction<{name:string,code:string}>)=>{
      // state.countryInfo.short_name = action.payload;
    },
    UpdateAddressfromAuto (state, action: PayloadAction<{
      address_line_one:string,
      address_line_two:string,
      city:string,
      state:string,
      postcode:string,
      country:string,
      countrycode:string,
      lat:string,
      long:string
    }>) {
     state.newuserData.shipment_address1=action.payload.address_line_one;
     state.newuserData.shipment_address2 = action.payload.address_line_two;
     state.newuserData.shipment_customer_city = action.payload.city;
     state.newuserData.shipment_state = action.payload.state;
     state.newuserData.shipment_postcode = action.payload.postcode;
     state.newuserData.shipment_latitude = action.payload.lat;
     state.newuserData.shipment_longitude = action.payload.long;
      state.newuserData.shipment_customer_country = action.payload.country;
      state.newuserData.shipment_country_code = action.payload.countrycode;
    },
  },
  extraReducers: builder => {
    builder.addCase(UserVerifyFromPostCodeThunk.pending, (state, action) => {
      state.isLoading = true;
    
    });
    builder.addCase(UserVerifyFromPostCodeThunk.fulfilled, (state, action) => {
      state.isLoading = false;
      if(action.payload.status){
      state.userData = action.payload.data;
     // console.log(state.userData);
      state.newuserData = action.payload.data;
      //console.log(state.newuserData);
      state.verifydata = action.payload.verify_info;
       state.countryInfo = action.payload.country_list;
       state.status = action.payload.status;
      } else{
        alert(action.payload.message);
      }
    });
    builder.addCase(UserVerifyFromPostCodeThunk.rejected, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(UpdateContactAddressActionThunk.pending, (state, action) => {
      state.isLoading = true;
    
    });
    builder.addCase(UpdateContactAddressActionThunk.fulfilled, (state, action) => {
      state.isLoading = false;
      if(action.payload.status == true){
        alert(action.payload.message);
      }else{
        alert(action.payload.message);
      }
     
    });
    builder.addCase(UpdateContactAddressActionThunk.rejected, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(UpdateTrackingAddressActionThunk.pending, (state, action) => {
      state.isLoading = true;
    
    });
    builder.addCase(UpdateTrackingAddressActionThunk.fulfilled, (state, action) => {
      state.isLoading = false; 
      if(action.payload.status == false){
          alert(action.payload.message);
      }else{
        alert(action.payload.message);
      }
     
    });
    builder.addCase(UpdateTrackingAddressActionThunk.rejected, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(verifyAddressThunk.pending, (state, action) => {
      state.isLoading = true;
    
    });
    builder.addCase(verifyAddressThunk.fulfilled, (state, action) => {
      state.isLoading = false;
      if(action.payload.status == true){
        state.status = action.payload.status;
        alert(action.payload.message);
      }else{
        //alert(action.payload.message);
      }
    });
    builder.addCase(verifyAddressThunk.rejected, (state, action) => {
      state.isLoading = false;
    });
  }
});

export const {updateCustomerEmail,updateCustomerName,
  updateCustomerPhone,updateShipmentAddress1,
  updateShipmentAddress2,updateShipmentCity,UpdateAddressfromAuto,
  updateShipmentState,updateShipmentCountry,updateShipmentPostcode,updateShipmentCountryCode,
  resetstatus,resetData,setLatLong} = UpdateTrackingAddressSlice.actions;

export default UpdateTrackingAddressSlice.reducer;
